import instance from "./axios";

export async function getPreviewAssignation(
  idEpisode: number,
  idClasse: string
) {
  try {
    const res = await instance.post(
      `/main/edifice/assignement/preview`,
      {
        idClasse,
        idEpisode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getPreviewAssignation] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getAssignStudentsForEpisode(
  idEpisode: number,
  idClasse: string
) {
  try {
    const res = await instance.post(
      `/main/edifice/assignement/students`,
      {
        idClasse,
        idEpisode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getPreviewAssignation] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function postBulkAssignStudent(
  idEpisode: number,
  idClasse: string,
  students: any
) {
  try {
    const res = await instance.post(
      `/main/edifice/assignement/bulk/students`,
      {
        idClasse,
        idEpisode,
        students,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.status;
  } catch (e) {
    console.log(`[getPreviewAssignation] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getSerieAssigned(idClasse: string) {
  try {
    const res = await instance.post(
      `/main/edifice/assignement/series`,
      {
        idClasse,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getPreviewAssignation] Il y a eu un problème : ${e}`);
    return null;
  }
}

export async function getAssignTo(idEpisode: number) {
  try {
    const res = await instance.post(
      `/main/edifice/assignement/unlocked`,
      {
        idEpisode,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (e) {
    console.log(`[getPreviewAssignation] Il y a eu un problème : ${e}`);
    return null;
  }
}
